<template>
    <div class="card future-settings-box arrow_box">
        <div class="card-header">
            Pending Changes
        </div>
        <div class="card-body">
            <p>
                Min range: {{ futureSettings.discountBundleDetails.minRange }}
            </p>
            <p>
                Max range: {{ futureSettings.discountBundleDetails.maxRange }}
            </p>
            <p>
                Discount: {{ futureSettings.discountBundleDetails.individualDiscount | discount(false) }}
            </p>
            <p>
                Effective Date: {{ futureSettings.effectiveDate | shortDate }}
            </p>
        </div>
    </div>
</template>

<script>

    export default {
        name: "AddDiscounts",
        props: {
            futureSettings: {type: [Object], required: true},
        },
        methods: {
            viewFutureDiscount(discount) {
				this.mapData('futureSettings', {...discount.futureSettings, effectiveDate: discount.futureSettings.effectiveDate});
				this.$refs.futureSettingsModal.open();
			},
        },
        async mounted() {
        },
    }
</script>

<style scoped>
    .future-settings-box {
        position: absolute;
        bottom: 13px;
        width: 200px;
        height: 158px;
        right: 47px;
    }
    .card-header {
        color: #2a9a71;
        padding: 9px 4px 3px 20px;
        margin: 0;
    }
    .card-body {
        padding-top: 8px;
    }
    .arrow_box:after,
    .arrow_box:before {
        bottom: 100%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        transform: rotate(179deg);
        bottom: -30px;
    }

    .arrow_box:after {
        border-color: rgba(255, 255, 255, 0);
        border-bottom-color: #ffffff;
        border-width: 15px;
        left: 50%;
        margin-left: -19px;
    }

    .arrow_box:before {
        border-color: rgba(113, 158, 206, 0);
        border-bottom-color: #cecece;
        border-width: 14px;
        left: 50%;
        margin-left: -18px;
    }
</style>